import React, { useEffect, useMemo, useState, useContext } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import HeaderBar from "../../components/HeaderBar";
import VehicleLayoutWrapper from "../../components/VehicleLayoutWrapper";
import getCurrentSkin from "../../utils/getCurrentSkin";
import { ThemeContext } from "../../context/ThemeContext";

import {
  FaPlus,
  FaSearch,
  FaList,
  FaEye,
  FaFilter,
  FaTrash,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const API_BASE = "https://nissi-india.com/api/ownDetailsListing";

const OwnDetailsListing = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  const navigate = useNavigate();

  // ✅ localStorage / sessionStorage values
  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const branchId = localStorage.getItem("branchId") || localStorage.getItem("branchid") || "";
  const branchType =
    localStorage.getItem("branchType") || localStorage.getItem("branchtype") || "BR";
  const userId =
    localStorage.getItem("userId") || localStorage.getItem("loginuserid") || "";
  const branchActive =
    sessionStorage.getItem("BranchActive") ||
    sessionStorage.getItem("branchActive") ||
    "1";

  // ✅ common headers
  const commonHeaders = useMemo(
    () => ({
      "x-finyearid": finYearId,
      "x-finyear": finYear,
      "x-branchid": branchId,
      "x-branch": branchType,
      "x-userid": userId,
    }),
    [finYearId, finYear, branchId, branchType, userId]
  );

  // View
  const [selectedView, setSelectedView] = useState("ownVehicle");

  // ddl/meta
  const [branches, setBranches] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [stores, setStores] = useState([]);
  const [spareBranches, setSpareBranches] = useState([]);
  const [spareMainTypes, setSpareMainTypes] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  // filters
  const [selectedBranchId, setSelectedBranchId] = useState(branchId || "");
  const [storeId, setStoreId] = useState("Select");
  const [vehicleTypeIndex, setVehicleTypeIndex] = useState("Select");

  const [vehicleCode, setVehicleCode] = useState("");
  const [vehicleName, setVehicleName] = useState("");
  const [vehicleRegNo, setVehicleRegNo] = useState("");
  const [vehicleMake, setVehicleMake] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");

  const [spareBranchId, setSpareBranchId] = useState(branchId || "Select");
  const [spareMainTypeId, setSpareMainTypeId] = useState("Select");
  const [spareVehicleCode, setSpareVehicleCode] = useState("");
  const [spareItem, setSpareItem] = useState("");
  const [spareModel, setSpareModel] = useState("");
  const [spareMake, setSpareMake] = useState("");
  const [spareSlNo, setSpareSlNo] = useState("");

  const [showFilters, setShowFilters] = useState(true);

  // list
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // selection
  const [selectedRows, setSelectedRows] = useState([]);

  // pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const totalPages = useMemo(() => {
    const t = Number(total);
    const l = Number(limit);
    if (!Number.isFinite(t) || !Number.isFinite(l) || l <= 0) return 1;
    return Math.max(1, Math.ceil(t / l));
  }, [total, limit]);

  const normalizeValue = (val) => {
    if (!val || val === "Select") return "";
    return String(val);
  };

  const getSelectedBranch = (overrideValue) => {
    if (branchType === "HO") {
      return overrideValue || selectedBranchId || branchId;
    }
    return branchId;
  };

  const normalizeRow = (row) => {
    if (selectedView === "ownVehicle") {
      return {
        ...row,
        rowId:
          row?.fld_vehicleown_detid ||
          row?.vehicleOwnDetId ||
          row?.ownDetId ||
          row?.id ||
          row?.fld_vehicleid ||
          0,
        vehicleId:
          row?.fld_vehicleid ||
          row?.vehicleId ||
          row?.VehicleID ||
          0,
        vehicleCode:
          row?.fld_vehicle_code ||
          row?.vehicleCode ||
          row?.VehicleCode ||
          "-",
        vehicleName:
          row?.fld_vehicle_name ||
          row?.vehicleName ||
          row?.VehicleName ||
          "-",
        vehicleRegNo:
          row?.fld_vehicle_regno ||
          row?.vehicleRegNo ||
          row?.VehicleRegNo ||
          "-",
        vehicleType:
          row?.fld_vehicletypename ||
          row?.vehicleType ||
          row?.VehicleType ||
          "-",
        make:
          row?.fld_vehiclemake ||
          row?.vehicleMake ||
          row?.make ||
          "-",
        model:
          row?.fld_vehicle_model ||
          row?.vehicleModel ||
          row?.model ||
          "-",
        chassisNo:
          row?.fld_Chassisno ||
          row?.fld_chasisno ||
          row?.chassisNo ||
          row?.chasisNo ||
          "-",
        invoiceNo:
          row?.fld_invoiceno ||
          row?.invoiceNo ||
          row?.invoiceNumber ||
          "-",
        purchaseDate:
          row?.fld_purchaseddate ||
          row?.purchaseDate ||
          "-",
        purchaseValue:
          row?.fld_purchased_amt ||
          row?.purchaseValue ||
          "-",
        cumHr:
          row?.fld_cumHMR ||
          row?.cumHr ||
          row?.cumHR ||
          "-",
        cumKm:
          row?.fld_cumKMR ||
          row?.cumKm ||
          row?.cumKM ||
          "-",
        branchName:
          row?.fld_branchname ||
          row?.fld_BranchName ||
          row?.branch ||
          "-",
      };
    }

    return {
      ...row,
      rowId:
        row?.fld_sparecatid ||
        row?.spareCatId ||
        row?.id ||
        0,
      slNo:
        row?.fld_slno ||
        row?.slNo ||
        "-",
      itemName:
        row?.fld_itemname ||
        row?.itemName ||
        row?.fld_description ||
        "-",
      vehicleCode:
        row?.fld_vehicle_code ||
        row?.vehicleCode ||
        "-",
      make:
        row?.fld_make ||
        row?.make ||
        "-",
      model:
        row?.fld_model ||
        row?.model ||
        "-",
      branchName:
        row?.fld_BranchName ||
        row?.fld_branchname ||
        row?.branch ||
        "-",
    };
  };

  // ---------- Meta ----------
  const loadMeta = async (branchParam) => {
    try {
      const selected = getSelectedBranch(branchParam);

      const r = await axios.get(`${API_BASE}/dropdowns`, {
        params: {
          branchId,
          loginUserId: userId,
          branchType,
          selectedBranchId: selected,
        },
        headers: commonHeaders,
      });

      const data = r.data?.data || {};
      setBranches(Array.isArray(data?.branches) ? data.branches : []);
      setVehicleTypes(Array.isArray(data?.vehicleTypes) ? data.vehicleTypes : []);
      setStores(Array.isArray(data?.stores) ? data.stores : []);
      setSpareBranches(Array.isArray(data?.spareBranches) ? data.spareBranches : []);
      setSpareMainTypes(Array.isArray(data?.spareMainTypes) ? data.spareMainTypes : []);

      if (branchType !== "HO") {
        setSelectedBranchId(String(branchId));
        setSpareBranchId(String(branchId));
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load dropdown data!");
      setBranches([]);
      setVehicleTypes([]);
      setStores([]);
      setSpareBranches([]);
      setSpareMainTypes([]);
    }
  };

  // ---------- Make / Model ----------
  const loadMakeModel = async (typeId) => {
    try {
      if (!typeId || typeId === "Select") {
        setMakeOptions([]);
        setModelOptions([]);
        return;
      }

      const r = await axios.get(`${API_BASE}/make-model`, {
        params: {
          vehicleTypeIndex: typeId,
        },
        headers: commonHeaders,
      });

      setMakeOptions(Array.isArray(r.data?.data?.makes) ? r.data.data.makes : []);
      setModelOptions(Array.isArray(r.data?.data?.models) ? r.data.data.models : []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load Make / Model");
      setMakeOptions([]);
      setModelOptions([]);
    }
  };

  // ---------- List ----------
  const loadList = async ({ mode = "search", nextPage = page, nextLimit = limit } = {}) => {
    if (!branchId) {
      toast.error("branchId missing in localStorage!");
      return;
    }

    setLoading(true);
    setSelectedRows([]);

    try {
      const selected = getSelectedBranch();

      const r = await axios.get(`${API_BASE}/list`, {
        params: {
          mode,
          view: selectedView,

          branchId,
          loginUserId: userId,
          branchType,
          selectedBranchId: selected,

          storeId: normalizeValue(storeId),
          vehicleTypeIndex: normalizeValue(vehicleTypeIndex),
          vehicleCode,
          vehicleName,
          vehicleRegNo,
          vehicleMake,
          vehicleModel,

          spareBranchId: normalizeValue(spareBranchId),
          spareMainTypeId: normalizeValue(spareMainTypeId),
          spareVehicleCode,
          spareItem,
          spareModel,
          spareMake,
          spareSlNo,

          page: nextPage,
          limit: nextLimit,
        },
        headers: commonHeaders,
      });

      const data = Array.isArray(r.data?.data) ? r.data.data : [];
      setRows(data.map(normalizeRow));

      const backendTotal = Number(r.data?.total);
      const backendPage = Number(r.data?.page);
      const backendLimit = Number(r.data?.limit);

      setTotal(Number.isFinite(backendTotal) ? backendTotal : data.length);
      setPage(Number.isFinite(backendPage) ? backendPage : nextPage);
      setLimit(Number.isFinite(backendLimit) ? backendLimit : nextLimit);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load list");
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // ---------- View All ----------
  const loadViewAll = async () => {
    setPage(1);
    await loadList({ mode: "all", nextPage: 1, nextLimit: limit });
  };

  // ---------- Branch change ----------
  const onBranchChange = async (e) => {
    const val = e.target.value;
    setSelectedBranchId(val);
    setStoreId("Select");
    setVehicleTypeIndex("Select");
    await loadMeta(val);
  };

  // ---------- Vehicle type change ----------
  const onVehicleTypeChange = async (e) => {
    const val = e.target.value;
    setVehicleTypeIndex(val);
    await loadMakeModel(val);
  };

  // ---------- Selection ----------
  const toggleRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const selectAll =
    rows.length > 0 &&
    selectedRows.length > 0 &&
    selectedRows.length === rows.length;

  const toggleAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(rows.map((r) => Number(r.rowId)).filter(Boolean));
    }
  };

  // ---------- Clear ----------
  const clearFilters = async () => {
    setStoreId("Select");
    setVehicleTypeIndex("Select");
    setVehicleCode("");
    setVehicleName("");
    setVehicleRegNo("");
    setVehicleMake("");
    setVehicleModel("");

    setSpareMainTypeId("Select");
    setSpareVehicleCode("");
    setSpareItem("");
    setSpareModel("");
    setSpareMake("");
    setSpareSlNo("");

    if (branchType === "HO") {
      setSpareBranchId("Select");
    } else {
      setSpareBranchId(String(branchId));
    }

    setMakeOptions([]);
    setModelOptions([]);
    toast.info("Filters cleared");
  };

  // ---------- Row action ----------
  const onEdit = (row) => {
    if (selectedView === "ownVehicle") {
      navigate(
        `/vehicle/OwnVehicle_DetailsEntry?vehicleId=${row.vehicleId || ""}&ownDetId=${
          row.rowId || ""
        }`
      );
      return;
    }

    navigate(`/vehicle/SparesCatalogueEntry?spareCatId=${row.rowId || ""}&mode=edit`);
  };

  // ---------- Delete ----------
  const onDeleteSelected = async () => {
    if (branchActive !== "1") {
      toast.error("Branch is inactive. Delete not allowed.");
      return;
    }

    const ids = selectedRows
      .map((x) => Number(x))
      .filter((x) => Number.isFinite(x) && x > 0);

    if (!ids.length) {
      toast.info("Select at least one row to delete.");
      return;
    }

    try {
      if (selectedView === "ownVehicle") {
        for (const id of ids) {
          // eslint-disable-next-line no-await-in-loop
          await axios.delete(`${API_BASE}/own-vehicles/${id}`, {
            headers: commonHeaders,
          });
        }
        toast.success("Deleted successfully");
      } else {
        const r = await axios.post(
          `${API_BASE}/spares/delete`,
          { ids },
          { headers: commonHeaders }
        );

        if (!r.data?.success) {
          toast.error(r.data?.message || "Delete failed");
          return;
        }
        toast.success(r.data?.message || "Deleted successfully");
      }

      await loadList({ nextPage: page, nextLimit: limit });
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Delete failed");
    }
  };

  // ---------- Single delete ----------
  const onDeleteOne = async (row) => {
    if (branchActive !== "1") {
      toast.error("Branch is inactive. Delete not allowed.");
      return;
    }

    try {
      if (selectedView === "ownVehicle") {
        const r = await axios.delete(`${API_BASE}/own-vehicles/${row.rowId}`, {
          headers: commonHeaders,
        });

        if (r.data?.success) {
          toast.success(r.data?.message || "Deleted successfully");
        } else {
          toast.error(r.data?.message || "Delete failed");
          return;
        }
      } else {
        const r = await axios.post(
          `${API_BASE}/spares/delete`,
          { ids: [row.rowId] },
          { headers: commonHeaders }
        );

        if (r.data?.success) {
          toast.success(r.data?.message || "Deleted successfully");
        } else {
          toast.error(r.data?.message || "Delete failed");
          return;
        }
      }

      await loadList({ nextPage: page, nextLimit: limit });
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Delete failed");
    }
  };

  // ---------- Initial load ----------
  useEffect(() => {
    (async () => {
      try {
        await loadMeta(selectedBranchId || branchId);
        await loadList({ nextPage: 1, nextLimit: limit });
      } catch (err) {
        console.error(err);
        toast.error("Failed to initialize page");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonHeaders, selectedView]);

  useEffect(() => {
    if (selectedView === "ownVehicle" && vehicleTypeIndex && vehicleTypeIndex !== "Select") {
      loadMakeModel(vehicleTypeIndex);
    } else if (selectedView === "ownVehicle") {
      setMakeOptions([]);
      setModelOptions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleTypeIndex, selectedView]);

  useEffect(() => {
    loadList({ nextPage: page, nextLimit: limit });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const pageNumbers = useMemo(() => {
    const tp = totalPages;
    const p = page;

    if (tp <= 1) return [1];

    const nums = new Set([1, tp, p, p - 1, p + 1, p - 2, p + 2]);
    const arr = [...nums].filter((n) => n >= 1 && n <= tp).sort((a, b) => a - b);

    const out = [];
    for (let i = 0; i < arr.length; i++) {
      out.push(arr[i]);
      if (i < arr.length - 1 && arr[i + 1] - arr[i] > 1) out.push("...");
    }
    return out;
  }, [page, totalPages]);

  const canPrev = page > 1;
  const canNext = page < totalPages;

  const addNewPath =
    selectedView === "ownVehicle"
      ? "/vehicle/OwnVehicle_DetailsEntry"
      : "/vehicle/SparesCatalogueEntry";

  return (
    <VehicleLayoutWrapper>
      <HeaderBar
        title={<span className="font-dmserif text-3xl">OWN VEHICLE DETAILS LISTING</span>}
        setSkin={setSkin}
        currentSkin={skin}
      />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
        {/* Top bar */}
        <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
          <div className="flex items-center gap-4">
            <h2 className={`text-xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
              {selectedView === "ownVehicle"
                ? "Own Vehicle Details Listing"
                : selectedView === "sparesAndCatalogue"
                ? "Spares And Catalogue Listing"
                : "Spares Scrap Listing"}
            </h2>

            <span
              className={`px-3 py-1 rounded-full text-sm font-medium ${
                isDark ? "bg-blue-900 text-blue-100" : "bg-blue-100 text-blue-800"
              }`}
            >
              {total || rows.length} Records
            </span>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`flex items-center gap-2 px-4 py-2 border rounded-lg transition-colors ${
                isDark
                  ? "border-gray-600 text-white hover:bg-gray-800" +
                    (showFilters ? " bg-gray-800" : "")
                  : "border-gray-300 text-gray-700 hover:bg-gray-50" +
                    (showFilters ? " bg-gray-50" : "")
              }`}
            >
              <FaFilter className="w-4 h-4" />
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>

            {branchActive === "1" && (
              <button
                onClick={() => navigate(addNewPath)}
                className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-4 py-2 rounded transition-colors`}
              >
                <FaPlus className="w-4 h-4" />
                Add New
              </button>
            )}
          </div>
        </div>

        {/* View selector */}
        <div
          className={`rounded-xl p-5 border mb-6 ${
            isDark ? "bg-gray-800 border-gray-700" : "bg-gray-50 border-gray-200"
          }`}
        >
          <div className="flex flex-wrap gap-6">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="viewSelection"
                value="ownVehicle"
                checked={selectedView === "ownVehicle"}
                onChange={() => {
                  setSelectedView("ownVehicle");
                  setPage(1);
                }}
              />
              <span className={isDark ? "text-white" : "text-gray-900"}>Own Vehicle</span>
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="viewSelection"
                value="sparesAndCatalogue"
                checked={selectedView === "sparesAndCatalogue"}
                onChange={() => {
                  setSelectedView("sparesAndCatalogue");
                  setPage(1);
                }}
              />
              <span className={isDark ? "text-white" : "text-gray-900"}>
                Spares And Catalogue
              </span>
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="viewSelection"
                value="sparesScrap"
                checked={selectedView === "sparesScrap"}
                onChange={() => {
                  setSelectedView("sparesScrap");
                  setPage(1);
                }}
              />
              <span className={isDark ? "text-white" : "text-gray-900"}>Spares Scrap</span>
            </label>
          </div>
        </div>

        {/* Filters */}
        {showFilters && (
          <div
            className={`rounded-xl p-5 border mb-6 ${
              isDark ? "bg-gray-800 border-gray-700" : "bg-gray-50 border-gray-200"
            }`}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* Branch */}
              {branchType === "HO" && (
                <div>
                  <label
                    className={`block text-sm font-medium mb-1 ${
                      isDark ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Branch
                  </label>
                  <select
                    value={selectedBranchId}
                    onChange={onBranchChange}
                    className={`w-full px-4 py-2 rounded-lg border ${
                      isDark
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                  >
                    <option value="">Select</option>
                    {branches.map((b, idx) => {
                      const id =
                        b?.id ||
                        b?.fld_Branchid ||
                        b?.BranchId ||
                        b?.branchid ||
                        b?.fld_branchid ||
                        "";
                      const name =
                        b?.name ||
                        b?.fld_BranchName ||
                        b?.BranchName ||
                        b?.branchname ||
                        id;
                      return (
                        <option key={idx} value={id}>
                          {name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}

              {selectedView === "ownVehicle" ? (
                <>
                  {/* Store */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Store
                    </label>
                    <select
                      value={storeId}
                      onChange={(e) => setStoreId(e.target.value)}
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white"
                          : "bg-white border-gray-300 text-gray-900"
                      }`}
                    >
                      <option value="Select">Select</option>
                      {stores.map((s, idx) => {
                        const id = s?.id || s?.fld_storeid || s?.StoreId || s?.storeid || "";
                        const name =
                          s?.name || s?.fld_storename || s?.StoreName || s?.storename || id;
                        return (
                          <option key={idx} value={id}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  {/* Vehicle Type */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Type
                    </label>
                    <select
                      value={vehicleTypeIndex}
                      onChange={onVehicleTypeChange}
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white"
                          : "bg-white border-gray-300 text-gray-900"
                      }`}
                    >
                      <option value="Select">Select</option>
                      {vehicleTypes.map((v, idx) => {
                        const id = v?.id || v?.vehicleTypeIndex || v?.VehicleTypeIndex || "";
                        const name = v?.name || v?.vehicleType || v?.VehicleType || id;
                        return (
                          <option key={idx} value={id}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  {/* Vehicle Code */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Code
                    </label>
                    <input
                      type="text"
                      value={vehicleCode}
                      onChange={(e) => setVehicleCode(e.target.value)}
                      placeholder="Vehicle Code"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* Vehicle Name */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Name
                    </label>
                    <input
                      type="text"
                      value={vehicleName}
                      onChange={(e) => setVehicleName(e.target.value)}
                      placeholder="Vehicle Name"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* Vehicle Reg No */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Reg No
                    </label>
                    <input
                      type="text"
                      value={vehicleRegNo}
                      onChange={(e) => setVehicleRegNo(e.target.value)}
                      placeholder="Vehicle Reg No"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* Make */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Make
                    </label>
                    <input
                      type="text"
                      value={vehicleMake}
                      onChange={(e) => setVehicleMake(e.target.value)}
                      placeholder="Vehicle Make"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* Model */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Model
                    </label>
                    <input
                      type="text"
                      value={vehicleModel}
                      onChange={(e) => setVehicleModel(e.target.value)}
                      placeholder="Vehicle Model"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>
                </>
              ) : (
                <>
                  {/* Spare Branch */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Spare Branch
                    </label>
                    <select
                      value={spareBranchId}
                      onChange={(e) => setSpareBranchId(e.target.value)}
                      disabled={branchType !== "HO"}
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white"
                          : "bg-white border-gray-300 text-gray-900"
                      } ${branchType !== "HO" ? "opacity-70 cursor-not-allowed" : ""}`}
                    >
                      <option value="Select">Select</option>
                      {spareBranches.map((b, idx) => {
                        const id = b?.id || b?.fld_Branchid || b?.branchid || "";
                        const name = b?.name || b?.fld_BranchName || b?.branchname || id;
                        return (
                          <option key={idx} value={id}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  {/* Main Type */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Main Type
                    </label>
                    <select
                      value={spareMainTypeId}
                      onChange={(e) => setSpareMainTypeId(e.target.value)}
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white"
                          : "bg-white border-gray-300 text-gray-900"
                      }`}
                    >
                      <option value="Select">Select</option>
                      {spareMainTypes.map((v, idx) => {
                        const id = v?.id || v?.mainTypeId || "";
                        const name = v?.name || v?.mainType || id;
                        return (
                          <option key={idx} value={id}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  {/* Spare Vehicle Code */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Vehicle Code
                    </label>
                    <input
                      type="text"
                      value={spareVehicleCode}
                      onChange={(e) => setSpareVehicleCode(e.target.value)}
                      placeholder="Vehicle Code"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* Item */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Item
                    </label>
                    <input
                      type="text"
                      value={spareItem}
                      onChange={(e) => setSpareItem(e.target.value)}
                      placeholder="Item Name"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* Spare Make */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Make
                    </label>
                    <input
                      type="text"
                      value={spareMake}
                      onChange={(e) => setSpareMake(e.target.value)}
                      placeholder="Make"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* Spare Model */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Model
                    </label>
                    <input
                      type="text"
                      value={spareModel}
                      onChange={(e) => setSpareModel(e.target.value)}
                      placeholder="Model"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>

                  {/* SL No */}
                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        isDark ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      SL No
                    </label>
                    <input
                      type="text"
                      value={spareSlNo}
                      onChange={(e) => setSpareSlNo(e.target.value)}
                      placeholder="SL No"
                      className={`w-full px-4 py-2 rounded-lg border ${
                        isDark
                          ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                          : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                      }`}
                    />
                  </div>
                </>
              )}

              {/* Buttons */}
              <div className="flex items-end gap-3 flex-wrap">
                <button
                  onClick={() => {
                    setPage(1);
                    loadList({ mode: "search", nextPage: 1, nextLimit: limit });
                  }}
                  className={`flex items-center gap-2 px-4 py-2 rounded text-white ${buttonClass} ${hoverClass}`}
                >
                  <FaSearch /> Search
                </button>

                <button
                  onClick={loadViewAll}
                  className="flex items-center gap-2 px-4 py-2 rounded border border-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  <FaList /> View All
                </button>

                <button
                  onClick={clearFilters}
                  className="flex items-center gap-2 px-4 py-2 rounded border border-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Bulk action */}
        {selectedRows.length > 0 && branchActive === "1" && (
          <div
            className={`rounded-lg p-4 mb-6 ${
              isDark ? "bg-blue-900/30 border border-blue-700" : "bg-blue-50 border border-blue-200"
            }`}
          >
            <div className="flex items-center justify-between">
              <div className={`font-semibold ${isDark ? "text-blue-200" : "text-blue-800"}`}>
                {selectedRows.length} item(s) selected
              </div>

              <button
                onClick={onDeleteSelected}
                className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                <FaTrash />
                Delete Selected
              </button>
            </div>
          </div>
        )}

        {/* Table */}
        <div
          className={`rounded-xl shadow-sm border overflow-hidden ${
            isDark ? "border-gray-700" : "border-gray-200"
          }`}
        >
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className={`${buttonClass} text-white`}>
                <tr>
                  <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">S.No</th>

                  {selectedView === "ownVehicle" ? (
                    <>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Vehicle Code
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Vehicle Name
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Vehicle Reg No
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Vehicle Type
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Make
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Model
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Chassis No
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Invoice No
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Purchase Date
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Purchase Value
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Cum HR
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Cum KM
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Branch
                      </th>
                    </>
                  ) : (
                    <>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        SL No
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Item
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Vehicle Code
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Make
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Model
                      </th>
                      <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">
                        Branch
                      </th>
                    </>
                  )}

                  <th className="px-4 py-4 text-left font-semibold whitespace-nowrap">Action</th>
                  <th className="px-4 py-4 text-center font-semibold whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={toggleAll}
                      className="mr-2"
                    />
                    Select All
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                {loading ? (
                  Array.from({ length: 5 }).map((_, idx) => (
                    <tr key={idx} className={isDark ? "bg-gray-800" : "bg-white"}>
                      {Array.from({
                        length: selectedView === "ownVehicle" ? 16 : 9,
                      }).map((__, i) => (
                        <td key={i} className="px-4 py-3">
                          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded animate-pulse w-24" />
                        </td>
                      ))}
                    </tr>
                  ))
                ) : rows.length === 0 ? (
                  <tr>
                    <td
                      colSpan={selectedView === "ownVehicle" ? 16 : 9}
                      className="px-4 py-8 text-center text-gray-500"
                    >
                      No records found.
                    </td>
                  </tr>
                ) : (
                  rows.map((row, idx) => (
                    <tr
                      key={row.rowId || idx}
                      className={`hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200 ${
                        isDark ? "bg-gray-900" : "bg-white"
                      }`}
                    >
                      <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">
                        {(page - 1) * limit + idx + 1}
                      </td>

                      {selectedView === "ownVehicle" ? (
                        <>
                          <td className="px-4 py-3">
                            <span className="text-blue-600 dark:text-blue-400 font-medium">
                              {row.vehicleCode}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.vehicleName}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.vehicleRegNo}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.vehicleType}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">{row.make}</td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">{row.model}</td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.chassisNo}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.invoiceNo}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.purchaseDate}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.purchaseValue}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">{row.cumHr}</td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">{row.cumKm}</td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.branchName}
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">{row.slNo}</td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.itemName}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.vehicleCode}
                          </td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">{row.make}</td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">{row.model}</td>
                          <td className="px-4 py-3 text-gray-900 dark:text-white">
                            {row.branchName}
                          </td>
                        </>
                      )}

                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => onEdit(row)}
                            disabled={branchActive !== "1"}
                            className={`px-3 py-1 rounded text-xs font-medium ${
                              isDark
                                ? "bg-blue-600 hover:bg-blue-700 text-white"
                                : "bg-blue-100 hover:bg-blue-200 text-blue-700"
                            } ${branchActive !== "1" ? "opacity-50 cursor-not-allowed" : ""}`}
                          >
                            <FaEye className="inline mr-1" />
                            Edit
                          </button>

                          <button
                            onClick={() => onDeleteOne(row)}
                            disabled={branchActive !== "1"}
                            className={`px-3 py-1 rounded text-xs font-medium ${
                              isDark
                                ? "bg-red-600 hover:bg-red-700 text-white"
                                : "bg-red-100 hover:bg-red-200 text-red-700"
                            } ${branchActive !== "1" ? "opacity-50 cursor-not-allowed" : ""}`}
                          >
                            <FaTrash className="inline mr-1" />
                            Delete
                          </button>
                        </div>
                      </td>

                      <td className="px-4 py-3 text-center">
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(Number(row.rowId))}
                          onChange={() => toggleRow(Number(row.rowId))}
                          className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mt-4">
          <div className={`text-sm ${isDark ? "text-gray-300" : "text-gray-700"}`}>
            Page <b>{page}</b> of <b>{totalPages}</b> &nbsp; | &nbsp; Total:{" "}
            <b>{total || rows.length}</b>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <label className={`text-sm ${isDark ? "text-gray-300" : "text-gray-700"}`}>
              Rows:
            </label>
            <select
              value={limit}
              onChange={(e) => {
                const v = Number(e.target.value || 10);
                setLimit(v);
                setPage(1);
              }}
              className={`px-3 py-2 border rounded-lg ${
                isDark
                  ? "bg-gray-700 border-gray-600 text-white"
                  : "bg-white border-gray-300 text-gray-900"
              }`}
            >
              {[10, 20, 50, 100].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>

            <button
              disabled={!canPrev}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              className={`px-3 py-2 border rounded-lg transition-colors ${
                isDark
                  ? `border-gray-600 ${canPrev ? "text-white hover:bg-gray-800" : "text-gray-500"}`
                  : `border-gray-300 ${
                      canPrev ? "text-gray-700 hover:bg-gray-50" : "text-gray-400"
                    }`
              }`}
            >
              Prev
            </button>

            {pageNumbers.map((n, i) =>
              n === "..." ? (
                <span
                  key={`dots-${i}`}
                  className={`px-2 ${isDark ? "text-gray-400" : "text-gray-500"}`}
                >
                  ...
                </span>
              ) : (
                <button
                  key={n}
                  onClick={() => setPage(Number(n))}
                  className={`px-3 py-2 border rounded-lg transition-colors ${
                    Number(n) === page
                      ? `${buttonClass} text-white border-transparent`
                      : isDark
                      ? "border-gray-600 text-white hover:bg-gray-800"
                      : "border-gray-300 text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {n}
                </button>
              )
            )}

            <button
              disabled={!canNext}
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              className={`px-3 py-2 border rounded-lg transition-colors ${
                isDark
                  ? `border-gray-600 ${canNext ? "text-white hover:bg-gray-800" : "text-gray-500"}`
                  : `border-gray-300 ${
                      canNext ? "text-gray-700 hover:bg-gray-50" : "text-gray-400"
                    }`
              }`}
            >
              Next
            </button>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          theme={isDark ? "dark" : "light"}
        />
      </div>
    </VehicleLayoutWrapper>
  );
};

export default OwnDetailsListing;